import React, { createContext, useState } from "react";
export const GlobalContext = createContext();

export const GlobalProvider = ({ children }) => {
  const [searchDtl, setSearchDtl] = useState({});
  const [user, setUser] = useState(JSON.parse(localStorage.getItem("user")));
  const [courses, setCourses] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [selection, setSelection] = useState("");
  const [teamRole, setTeamRole] = useState({});

  const setSearchDetails = (payload) => {
    setSearchDtl({
      ...searchDtl,
      ...payload,
    });
  };

  return (
    <GlobalContext.Provider
      value={{
        searchDtl,
        setSearchDetails,
        courseChange: [courses, setCourses],
        popup: { showPopup, setShowPopup },
        navig: { selection, setSelection },
        user: [user, setUser],
        teamRole: [teamRole, setTeamRole],
      }}
    >
      {children}
    </GlobalContext.Provider>
  );
};
export default GlobalContext;
